import { useParams } from 'react-router-dom';
import { UserPage } from '@/features/user-console/user-page';

// Route: /operations/users/:pid (registered in routing.tsx during shell wiring,
// alongside the /kyc and /pii redirect stubs)
const UserDetailPage = () => {
  const { pid = '' } = useParams<{ pid: string }>();
  return <UserPage pid={pid} />;
};
UserDetailPage.displayName = 'UserDetailPage';

export default UserDetailPage;
